import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "bidrectional-arrow",
  "use": "bidrectional-arrow-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol viewBox=\"0 0 26 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"bidrectional-arrow\">\n<rect width=\"26\" height=\"26\" fill=\"black\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.797 13.2986L21.1484 9.14932L13.797 5V7.84247L6 7.84247L6 10.4559L13.797 10.4559V13.2986Z\" fill=\"white\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.3514 13.9999L5.00004 18.1493L12.3514 22.2986L12.3514 19.4561L20.1484 19.4561L20.1484 16.8427L12.3514 16.8427L12.3514 13.9999Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol